import React from "react";

import { useHistory } from "react-router-dom";

// Components imports
import Button from "../../common/Button";

// Scss imports
import css from "./ArchiveNavigation.module.scss";

// redux
import { useDispatch } from "react-redux";
import { getAllPagePapers } from "../../../redux/actions/papersActions";

interface ArchiveNavigationProps {
  buttonText: string;
  setPapersData: Function;
  allPageArchive: [];
  certainPageArchive: [];
  setPapers: Function;
  setButtonText: Function;
  setPapersTitle: Function;
  setActivePage: Function;
  activePage: number;
  pageLimit: number;
}

const ArchiveNavigation: React.FC<ArchiveNavigationProps> = ({
  buttonText,
  setPapersData,
  allPageArchive,
  certainPageArchive,
  setPapers,
  setButtonText,
  setPapersTitle,
  setActivePage,
  activePage,
  pageLimit,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <div className={css.container}>
      <div className={css.buttonWrapper}>
        {/*<Button
          text={buttonText}
          onButtonClickHandler={() => {
            if (buttonText === "Прикажи све") {
              setPapers("archive");
              setButtonText("Прикажи тренутну");
              setPapersTitle("Архивска књига за све године");
              setActivePage(1);
              dispatch(getAllPagePapers(activePage, pageLimit, ""));
            } else if (buttonText === "Прикажи тренутну") {
              setPapers("archiveLastYear");
              setButtonText("Прикажи све");
              setPapersTitle(
                `Архивска књига ${new Date().getFullYear()} годину`
              );
              dispatch(getAllPagePapers(activePage, pageLimit, ""));
              setActivePage(1);
            }
          }}
          type="papersNavigationButton"
        />*/}
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Унеси документа"
          onButtonClickHandler={() => {
            history.push("/record-book");
          }}
          type="papersNavigationButton"
        />
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Уништи архиву"
          onButtonClickHandler={() => {
            history.push("/destroy-archive");
          }}
          type="papersNavigationButton"
        />
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Додај архиву"
          onButtonClickHandler={() => {
            history.push("/add-archive");
          }}
          type="papersNavigationButton"
        />
      </div>
    </div>
  );
};

export default ArchiveNavigation;
